import RightIcon from 'components/blog/icons/right'
import Image from 'next/legacy/image'
import Link from 'next/link'
import { Author } from '../../../types/blog-types'
import s from './styles.module.css'

interface ExpertCardProps {
  expert: Author
}

export default function ExpertCard({ expert }: ExpertCardProps) {
  return (
    <Link href={`blog/expert/${expert.fields.slug}`} className={s.expertCard}>
      <div className={s.imageWrapper}>
        <Image
          alt={expert.fields.profileImage.fields.title}
          src={`https:${expert.fields.profileImage.fields.file.url}`}
          layout="fill"
          objectFit="cover"
          objectPosition="top center"
        />
      </div>
      <div className={s.content}>
        <h2 className={s.name}>{expert.fields.name}</h2>
        <p className={s.bio}>{expert.fields.bio}</p>
        <div className={s.learnMore}>
          <span>Learn More</span>
          <RightIcon />
        </div>
      </div>
    </Link>
  )
}
